import { useRef, useState, useEffect } from "react";
import { useTheme } from "@emotion/react";
import { Box, Grid, IconButton, Typography, Button } from "@mui/material";
import { PiUploadSimple } from "react-icons/pi";
import { HiOutlineTrash } from "react-icons/hi";
import { AiFillCheckCircle } from "react-icons/ai";
import { AppEntryRepository } from "../repositories/AppEntryRepository";

export default function ApplicantEntryCorrection({ appEntry, setAppEntry }) {
  const theme = useTheme();
  const fileInputRef = useRef(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const handleFileUpload = (files) => {
    const newFiles = Array.from(files).filter(
      (file) => !uploadedFiles.some((f) => f.name === file.name)
    );
    if (newFiles.length > 0) {
      setUploadedFiles((prev) => [...prev, ...newFiles]);
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleDeleteFile = (indexToRemove) => {
    setUploadedFiles((prev) =>
      prev.filter((_, index) => index !== indexToRemove)
    );
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const uploadCorrectionFiles = () => {
    const formPayload = new FormData();
    formPayload.append("appEntryId", appEntry?.id);

    uploadedFiles.forEach((file) => {
      formPayload.append("correctionFiles", file);
    });

    AppEntryRepository.uploadCorrectionFiles(formPayload)
      .then((res) => {
        console.log(res.data);
        setUploadedFiles([]);
        setAppEntry(res.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <Grid
      container
      className="corrections-container"
      sx={{
        overflow: "hidden",
      }}
    >
      <Typography variant="h6" sx={{ mb: 1.5, pt: 2 }}>
        Барање за корекција
      </Typography>
      <Grid item xs={12}>
        <div
          className="corrections-title"
          style={{
            borderLeft: `4px solid ${theme.palette.primary.main}`,
          }}
        >
          <Typography variant="caption" color="text.secondary">
            Причина за корекција
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontFamily: "Inter-Bold",
              color: theme.palette.warning.main,
            }}
          >
            {appEntry?.correctionReason}
          </Typography>
        </div>
        <Grid container spacing={0}>
          <Grid
            item
            xs={6}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: "10px 0",
            }}
          >
            <input
              type="file"
              ref={fileInputRef}
              multiple
              onChange={(e) => handleFileUpload(e.target.files)}
              style={{ display: "none" }}
              id="file-upload"
            />
            <label
              htmlFor="file-upload"
              style={{ width: "100%", cursor: "pointer" }}
            >
              <Box
                sx={{
                  border: `1px solid #ccc`,
                  padding: "10px",
                  textAlign: "center",
                  transition: "border-color 0.2s",
                }}
              >
                <PiUploadSimple color={theme.palette.primary.main} size={20} />
                <Typography variant="body2" color="text.secondary">
                  Коригираните документи прикачете ги тука
                </Typography>
              </Box>
            </label>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{
              p: 2,
            }}
          >
            {uploadedFiles.length > 0 &&
              uploadedFiles.map((file, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    flexWrap: "nowrap",
                    alignItems: "center",
                    background: "#fff",
                    p: 0,
                    gap: 1,
                    width: "100%",
                    minWidth: 0,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "13px",
                      flex: 1,
                      minWidth: 0,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      color: theme.palette.secondary.main,
                    }}
                  >
                    {file.name} ({(file.size / 1024).toFixed(1)} KB)
                  </Typography>
                  <AiFillCheckCircle
                    color="#4caf50"
                    size={18}
                    style={{ flexShrink: 0 }}
                  />
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDeleteFile(index);
                    }}
                    sx={{ p: 0, flexShrink: 0 }}
                  >
                    <HiOutlineTrash size={18} color="#f44336" />
                  </IconButton>
                </Box>
              ))}
          </Grid>
          {uploadedFiles.length > 0 && (
            <Grid item xs={12} style={{ padding: "10px 0" }}>
              <Button
                variant="contained"
                size="large"
                className="login-button"
                style={{ float: "right" }}
                onClick={() => uploadCorrectionFiles()}
              >
                <Typography className="login-button-text">Поднеси</Typography>
              </Button>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}
